import { service } from '@ember/service';

import { Ability } from 'ember-can';

export default class DashboardAbility extends Ability {
  // Services
  @service permission;

  // Getter and setter
  get canViewNavigation() {
    return true;
  }

  get canRead() {
    return true;
  }

  get canViewNews() {
    return this.permission.userRoles.find((userRole) => {
      return !['20'].includes(userRole.id);
    });
  }
}
